<template>
  <div class="x-tablelist-view" data-automation="manageProduct">

    <div class="search-warp">
      <el-row type="flex" justify="start" :gutter="16" align="middle">
        <el-col :span="8">
          <add-imei-input v-model="filter.deviceImei" :showAdd="false"
            ></add-imei-input>
        </el-col>
        <el-col>
          <el-button type="primary" @click="seach" size="small">{{
            $t('HT.search')
          }}</el-button>
          <el-button plain @click="reset" size="small">{{
            $t('HT.reset')
          }}</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table ref="table" :showPage="showPage" maxHeight="100%" :hide-on-single-page="true" :data="tableData.list"
        :columns="columns1" :total="tableData.totalSize" :size.sync="filter.size" :page.sync="filter.page"
        @changePage="changePage" @changeSize="changeSize" :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
  
<script>
import AddImeiInput from '@/components/AddImeiInput/index.vue';
export default {
  components: {
    AddImeiInput
  },
  data() {
    return {
      userData: {}, // 登录者信息
      showPage: true,
      isShow: true,
      columns1: [
        // 表头数据
        {
          label: this.$t('HT.label.imei'),
          tooltip: true,
          align: 'left',
          prop: 'device_imei'
        },
        {
          label: this.$t('HT.unbindApi.name'),
          prop: 'product_name',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.label.api'),
          prop: 'api_name',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.label.todayCall'),
          prop: 'invoke_of_day',
          align: 'left',
          tooltip: true,
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.goToLog('today', params);
                  }
                }
              },
              params.invoke_of_day
            );
          }
        },
        {
          label: this.$t('HT.label.totalCall'),
          prop: 'invoke_of_total',
          align: 'left',
          tooltip: true,
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.goToLog('total',params);
                  }
                }
              },
              params.invoke_of_total
            );
          }
        },

        {
          label: this.$t('HT.label.firstCallTime'),
          prop: 'first_call_time',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(8),
          align: 'left',
          width: 250,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [
                  this.$t('HT.common.detail'),
                ],
                className: [
                  '',
                  this.userData.supervisor && params.published != 2 ? '' : 'no-click',
                  params.published == 0 ? 'no-click' : '',
                  ''
                ],
                event: ['goToDetail']
              },
              on: {
                // 管理
                goToDetail: () => {
                  this.goToDetail(params);
                },

              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        deviceImei: '',
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getAllList();
    this.getSupervisor();
    this.userData = this.$store.state.login.userData;
  },

  methods: {
    /**
     * 获取超级管理员字段
     * @param {String}
     */
    getSupervisor() {
      this.isShow = JSON.parse(localStorage.getItem('userData')).supervisor;
    },

    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getAllList() {
      const params = Object.assign({}, this.filter);
      params.deviceImei = params.deviceImei.replace(/[(\r\n)\r\n]+/g, ',');
      this.$uxLoading.show();
      this.$api.device.getDeviceList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },


    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getAllList();
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getAllList();
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getAllList();
    },
    reset() {
      this.filter.deviceImei = '';
      this.filter.page = 1;
      this.filter.size = 10;
      this.getAllList();
    },
    goToDetail(params) {
      sessionStorage.setItem('deviceDetail', JSON.stringify(params));
      this.$router.push({ name: 'deviceDetail', params: { id: params.id } });
    },
    goToLog(type, { device_imei, first_call_time }) {
      let startTime='',endTime='';
      if(type==='total'){
        startTime=first_call_time;
      }else{
        startTime=this.$uxSdk.time.format('YYYY-MM-DD hh:mm:ss',new Date().setHours(0, 0, 0, 0));
      }
      endTime= this.$uxSdk.time.format('YYYY-MM-DD hh:mm:ss');
      this.$router.push({ path: '/device/log', query: { deviceImei: device_imei, startTime,endTime } });
    }
  }
};
</script>
  